var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"golf-protection-form-wrap"},[_c('golf-protection-form',{attrs:{"showSkipButton":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }